const CONTACT_SUBJECT = {
  GENERAL: {
    i18nKey: "frontend.common.contact.form.subject.general",
    key: "GENERAL",
  },
  SALES: {
    i18nKey: "frontend.common.contact.form.subject.sales",
    key: "SALES",
  },
  SERVICE: {
    i18nKey: "frontend.common.contact.form.subject.service",
    key: "SERVICE",
  },
  ACCOUNTING: {
    i18nKey: "frontend.common.contact.form.subject.accounting",
    key: "ACCOUNTING",
  },
  IT: {
    i18nKey: "frontend.common.contact.form.subject.it",
    key: "IT",
  },
  JOBS: {
    i18nKey: "frontend.common.contact.form.subject.jobs",
    key: "JOBS",
  },
  OTHER: {
    i18nKey: "frontend.common.contact.form.subject.other",
    key: "OTHER",
  },
};

export { CONTACT_SUBJECT };
